/**
 * Best-effort testimonial byline from an account email, matching the convention used on the
 * chapter roast landing page: first name + last initial.
 *
 * Feedback rows carry no name, only the account email, so this is a suggestion the admin can
 * overwrite. Anything that does not clearly decompose into two name-like parts falls back to the
 * anonymous label — publishing "A Twig writer" is honest, inventing a surname is not.
 */
export const ANONYMOUS_BYLINE = 'A Twig writer';

export function suggestDisplayName(email: string | null | undefined): string {
  const local = (email ?? '').split('@')[0]?.toLowerCase() ?? '';
  const parts = local.split(/[._-]+/).filter(part => part.length > 1 && !/\d/.test(part));
  const [first, second] = parts;
  if (!first || !second) return ANONYMOUS_BYLINE;
  return `${first.charAt(0).toUpperCase()}${first.slice(1)} ${second.charAt(0).toUpperCase()}.`;
}
